import React from 'react';
import styled from 'styled-components/macro';
import { distances, colors, border } from '../../../styles/constants';
import { H3 } from '../../../components/Typography';

interface DiscountSectionProps {
    label: string;
    children: React.ReactNode;
}

const DiscountSection = (
    {
        label,
        children,
    }: DiscountSectionProps
) => {
    return (
        <Section>
            <Label>{label}</Label>
            {children}
        </Section>
    );
};

const Section = styled.div`
    width: 100%;
    margin: ${distances.normal} 0;
`;

const Label = styled(H3 as any)`
    background-color: ${colors.backgroundAlt};
    margin: 0 -${distances.normal} ${distances.small};
    padding: ${distances.small} ${distances.normal};
    border-top: ${border.normal} solid ${colors.borderLight};
`;

export default DiscountSection;
